import PlanReadyCommunication from '~/pages/communication/planReady/libs/components/PlanReadyCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const PlanReadyCommunicationPage = (props: TPageProps) => (
  <PlanReadyCommunication {...props} />
)

export default PlanReadyCommunicationPage
